/**
 * Faction pentagon / HUD slot: background colors and icon paths (battle PlayerHUD / OpponentHUD).
 */

const factionColors = {
  "Remnants of Humanity": "#556B2F",
  "Exolot Dominion": "#4B0082",
  "League of Shadows": "#1A1A1A",
  "Ra's Children": "#F4A460",
  Asrah: "#8B0000",
  "The Sentients": "#ADD8E6",
  Combined: "#FFA500",
};

const factionIconByName = {
  "Remnants of Humanity": "remnants.png",
  "Exolot Dominion": "exolot.png",
  "League of Shadows": "league.png",
  "Ra's Children": "ra.png",
  Asrah: "asrah.png",
  "The Conspiracy": "conspiracy.png",
  "The Corrupted Core": "core.png",
  "The Covenant": "covenant.png",
  "The Divine Syndicate": "syndicate.png",
  "The Forsaken Pact": "forsaken.png",
  "The Hollow": "hollow.png",
  "The Iron Alliance": "alliance.png",
  "The Last Crusade": "crusade.png",
  "The Shadow Consortium": "consortium.png",
  "The Silent Accord": "silent.png",
};

export function getFactionBoxBackground(factionName) {
  if (!factionName || factionName === "Unknown") {
    return "#444";
  }

  if (factionName === "The Conspiracy") {
    return "linear-gradient(to right, #8B0000 50%, #1A1A1A 50%)";
  }
  if (factionName === "The Corrupted Core") {
    return "linear-gradient(to right, #4B0082 50%, #8B0000 50%)";
  }
  if (factionName === "The Covenant") {
    return "linear-gradient(to right, #F4A460 50%, #1A1A1A 50%)";
  }
  if (factionName === "The Divine Syndicate") {
    return "linear-gradient(to right, #F4A460 50%, #4B0082 50%)";
  }
  if (factionName === "The Forsaken Pact") {
    return "linear-gradient(to right, #556B2F 50%, #8B0000 50%)";
  }
  if (factionName === "The Hollow") {
    return "linear-gradient(to right, #F4A460 50%, #8B0000 50%)";
  }
  if (factionName === "The Iron Alliance") {
    return "linear-gradient(to right, #556B2F 50%, #4B0082 50%)";
  }
  if (factionName === "The Last Crusade") {
    return "linear-gradient(to right, #F4A460 50%, #556B2F 50%)";
  }
  if (factionName === "The Shadow Consortium") {
    return "linear-gradient(to right, #1A1A1A 50%, #4B0082 50%)";
  }
  if (factionName === "The Silent Accord") {
    return "linear-gradient(to right, #556B2F 50%, #1A1A1A 50%)";
  }

  return factionColors[factionName] || "#444";
}

export function getFactionIconPath(factionName) {
  if (!factionName || factionName === "Unknown" || factionName === "The Sentients") {
    return null;
  }

  const iconFile = factionIconByName[factionName];
  if (!iconFile) {
    throw new Error(`Faction HUD icon mapping missing for faction: ${factionName}`);
  }

  return `${process.env.PUBLIC_URL}/factions/${iconFile}`;
}
